'use client';

import { ResetIcon } from '@/icons';
import { usePrint } from '@/lib/hooks';
import { PageProps, ParamsWithLocale, StructureData } from '@/lib/types';
import { Breadcrumb, Empty, Section } from '@/ui';
import { Content } from '@/widgets';
import { Box, Container, UnstyledButton } from '@mantine/core';
import { useTranslations } from 'next-intl';
import { Fragment, useState } from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import Chart from './Chart';
import './chart.css';

type Props = ParamsWithLocale & {
  structure: PageProps & {
    title: string;
    data: StructureData[][];
  };
};

export default function Structure({ locale, structure }: Props) {
  const t = useTranslations();
  const { ref, handlePrint } = usePrint();

  const breadcrumbItems = [
    { title: structure?.breadcrumb, href: `/general-menu/${structure?.menu_id}` },
    { title: structure?.title, isCurrent: true },
  ];

  return (
    <Container>
      <Section
        rightMenu={{
          isActive: true,
          id: structure?.menu_id,
          activeItem: { id: structure?.menu_item_id },
        }}
      >
        <Content ref={ref}>
          <Content.Header details={{ handlePrint }}>
            <Breadcrumb items={breadcrumbItems} />
          </Content.Header>
          <Content.Title>{structure?.title}</Content.Title>
          <Content.Body isShareable>
            {/* {structure?.data?.length > 0 ? (
              <Box>
                <TransformWrapper doubleClick={{ disabled: true }}>
                  {({ zoomIn, zoomOut, resetTransform }) => (
                    <Fragment>
                      <div className="chart-tools">
                        <UnstyledButton onClick={() => zoomIn(0.1)} aria-label={t('Kattalashtirish')}>
                          +
                        </UnstyledButton>
                        <UnstyledButton onClick={() => zoomOut(0.1)} aria-label={t('Kichiklashtirish')}>
                          -
                        </UnstyledButton>
                        <UnstyledButton
                          onClick={() => resetTransform()}
                          aria-label={t('Boshlang‘ich holatga qaytarish')}
                        >
                          <ResetIcon />
                        </UnstyledButton>
                      </div>
                      <Box className="chart-wrapper">
                        <TransformComponent>
                          <Chart locale={locale} authority={authority} data={structure?.data} />
                        </TransformComponent>
                      </Box>
                    </Fragment>
                  )}
                </TransformWrapper>
              </Box>
            ) : (
              <Empty />
            )} */}
            {structure?.data?.length > 0 ? (
              <Box className="chart-wrapper">
                <Chart locale={locale} data={structure?.data} />
              </Box>
            ) : (
              <Empty />
            )}
          </Content.Body>
        </Content>
      </Section>
    </Container>
  );
}
